(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  class CartForm extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.changeUrl = this.dataset.changeUrl + '.js';

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
    }

    onClick(event) {
      const stepper = event.target.closest('[data-qty]');
      if (stepper) {
        const row = stepper.closest('.cart-item');
        const input = row.querySelector('.qty__input');
        let value = parseInt(input.value, 10);
        if (isNaN(value)) value = 0;
        value += stepper.dataset.qty === 'up' ? 1 : -1;
        if (value < 0) value = 0;
        this.updateLine(row, value);
        return;
      }

      const remove = event.target.closest('[data-remove]');
      if (remove) {
        event.preventDefault();
        this.updateLine(remove.closest('.cart-item'), 0);
      }
    }

    onChange(event) {
      const input = event.target.closest('.qty__input');
      if (!input) return;
      let value = parseInt(input.value, 10);
      if (isNaN(value) || value < 0) value = 0;
      this.updateLine(input.closest('.cart-item'), value);
    }

    async updateLine(row, quantity) {
      if (!row || this.busy) return;
      this.busy = true;
      row.classList.add('is-loading');
      this.showError('');

      try {
        const response = await fetch(this.changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line: Number(row.dataset.line),
            quantity: quantity,
            sections: this.sectionId,
            sections_url: window.location.pathname,
          }),
        });

        const data = await response.json();

        if (!response.ok) {
          this.showError(data.description || data.message || '');
          row.classList.remove('is-loading');
          return;
        }

        this.render(data);
      } catch (error) {
        window.location.reload();
      } finally {
        this.busy = false;
      }
    }

    render(data) {
      const markup = data.sections && data.sections[this.sectionId];
      if (!markup) {
        window.location.reload();
        return;
      }

      const fresh = new DOMParser().parseFromString(markup, 'text/html').querySelector('cart-form');
      if (fresh) this.innerHTML = fresh.innerHTML;

      document.querySelectorAll('[data-cart-count]').forEach((node) => {
        node.textContent = data.item_count;
        node.classList.toggle('is-empty', data.item_count === 0);
      });

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
    }

    showError(message) {
      const target = this.querySelector('[data-cart-errors]');
      if (!target) return;
      target.textContent = message;
      target.classList.toggle('is-visible', Boolean(message));
    }
  }

  if (!customElements.get('cart-form')) {
    customElements.define('cart-form', CartForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  /* Sur mobile, les facettes sont repliées pour laisser les produits visibles
     dès l'arrivée. Sans JavaScript, elles restent ouvertes (donc utilisables). */
  (function () {
    var aside = document.querySelector('.collection__aside');
    if (!aside) return;
    // Replié par défaut pour laisser les produits en tête ; on le laisse
    // ouvert si le visiteur a déjà des filtres actifs.
    var hasActive = aside.querySelector('input:checked') !== null || aside.querySelector('.filter-price__input[value]:not([value=""])') !== null;
    if (!hasActive) aside.open = false;
  })();

  /**
   * Recherche sur la page : filtre les cartes déjà affichées pendant la frappe.
   * Le périmètre est volontairement explicite - seule la page courante est
   * filtrée - et un lien propose d'élargir la recherche à tout le catalogue,
   * ce que fait aussi la touche Entrée (envoi normal du formulaire).
   */
  (function () {
    var form = document.querySelector('[data-collection-search]');
    var grid = document.querySelector('[data-collection-grid]');
    if (!form || !grid) return;

    var input = form.querySelector('[data-collection-search-input]');
    var counter = document.querySelector('[data-collection-count]');
    var empty = grid.querySelector('[data-no-local]');
    var emptyText = grid.querySelector('[data-no-local-text]');
    var emptyLink = grid.querySelector('[data-no-local-link]');
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.product-card'));
    var totalLabel = counter ? counter.textContent.trim() : '';
    var strings = JSON.parse(document.getElementById('collection-search-strings').textContent);

    function normalize(value) {
      return value
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    }

    var haystacks = cards.map(function (card) {
      return normalize(card.textContent);
    });

    function render(terms) {
      var query = normalize(terms.trim());

      if (!query) {
        cards.forEach(function (card) {
          card.classList.remove('is-filtered-out');
        });
        if (counter) counter.textContent = totalLabel;
        if (empty) empty.classList.remove('is-visible');
        return;
      }

      var shown = 0;
      cards.forEach(function (card, index) {
        var match = haystacks[index].indexOf(query) !== -1;
        card.classList.toggle('is-filtered-out', !match);
        if (match) shown += 1;
      });

      if (counter) {
        counter.textContent = strings.filtered.replace('[nombre]', shown);
      }
      if (empty) {
        empty.classList.toggle('is-visible', shown === 0);
        if (shown === 0) {
          if (emptyText) emptyText.textContent = strings.none.replace('[terme]', terms.trim());
          if (emptyLink) {
            emptyLink.textContent = strings.all.replace('[terme]', terms.trim());
            emptyLink.href = strings.searchUrl + '?type=product&q=' + encodeURIComponent(terms.trim());
          }
        }
      }
    }

    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        render(input.value);
      }, 120);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StoreHeader extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.header__bar');
      this.threshold = parseInt(this.dataset.scrollThreshold, 10) || 24;
      this.onScroll = this.onScroll.bind(this);
      this.onScroll();
      window.addEventListener('scroll', this.onScroll, { passive: true });

      this.setupAnnouncement();
      this.setupDetails();
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.closeAllPanels();
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      this.classList.toggle('is-scrolled', window.scrollY > this.threshold);
    }

    setupAnnouncement() {
      const items = Array.from(this.querySelectorAll('.header__announcement-item'));
      if (items.length < 2) return;
      let index = 0;
      setInterval(() => {
        items[index].classList.remove('is-active');
        index = (index + 1) % items.length;
        items[index].classList.add('is-active');
      }, 4000);
    }

    setupDetails() {
      // Ferme les autres panneaux quand on en ouvre un, et gère le clic hors zone.
      this.panels = Array.from(this.querySelectorAll('details'));
      this.panels.forEach((panel) => {
        panel.addEventListener('toggle', () => {
          if (!panel.open) return;
          this.panels.forEach((other) => {
            if (other !== panel && !other.contains(panel)) other.open = false;
          });
        });
      });

      // Ferme un overlay (menu/recherche) au clic sur le fond ou un lien.
      this.querySelectorAll('.mobile-menu, .search-overlay').forEach((overlay) => {
        const parent = overlay.closest('details');
        overlay.addEventListener('click', (event) => {
          if (event.target === overlay || event.target.closest('a')) {
            parent.open = false;
          }
        });
      });

      // Les <label> de fermeture referment le <details> parent.
      this.querySelectorAll('.mobile-menu__close, .search-overlay__close').forEach((btn) => {
        btn.addEventListener('click', () => {
          const parent = btn.closest('details');
          if (parent) parent.open = false;
        });
      });
    }

    closeAllPanels() {
      this.querySelectorAll('details[open]').forEach((panel) => {
        panel.open = false;
      });
    }
  }

  if (!customElements.get('store-header')) {
    customElements.define('store-header', StoreHeader);
  }

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[name="q"]');
      this.results = this.querySelector('[data-predictive-results]');
      this.searchUrl = this.dataset.searchUrl;
      this.emptyText = this.dataset.empty;
      this.allLabel = this.dataset.allLabel;
      this.timer = null;
      if (!this.input || !this.results) return;
      this.input.addEventListener('input', () => this.onInput());
    }

    onInput() {
      clearTimeout(this.timer);
      const q = this.input.value.trim();
      if (q.length < 2) {
        this.results.hidden = true;
        this.results.textContent = '';
        return;
      }
      this.timer = setTimeout(() => this.search(q), 250);
    }

    search(q) {
      const url =
        '/search/suggest.json?q=' +
        encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((data) => {
          const products = (data.resources && data.resources.results && data.resources.results.products) || [];
          this.render(q, products);
        })
        .catch(() => {
          this.results.hidden = true;
        });
    }

    render(q, products) {
      this.results.textContent = '';
      if (!products.length) {
        const empty = document.createElement('p');
        empty.className = 'ps__empty';
        empty.textContent = this.emptyText;
        this.results.appendChild(empty);
        this.results.hidden = false;
        return;
      }
      const grid = document.createElement('div');
      grid.className = 'ps__grid';
      products.forEach((p) => {
        const a = document.createElement('a');
        a.className = 'ps__item';
        a.href = p.url;
        const media = document.createElement('span');
        media.className = 'ps__img';
        if (p.image || p.featured_image) {
          const img = document.createElement('img');
          img.src = p.image || (p.featured_image && p.featured_image.url);
          img.alt = '';
          img.loading = 'lazy';
          media.appendChild(img);
        }
        const title = document.createElement('span');
        title.className = 'ps__title';
        title.textContent = p.title;
        a.appendChild(media);
        a.appendChild(title);
        grid.appendChild(a);
      });
      const all = document.createElement('a');
      all.className = 'ps__all';
      all.href = this.searchUrl + '?q=' + encodeURIComponent(q);
      all.textContent = this.allLabel;
      this.results.appendChild(grid);
      this.results.appendChild(all);
      this.results.hidden = false;
    }
  }

  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-flottant"] && !Shopify.designMode) return;
  try {
    
  /**
   * Héro flottant : dérive au défilement.
   *
   * Un seul écouteur de défilement passif, une frame demandée à la fois, et
   * une variable CSS écrite sur la section. Chaque calque applique ensuite sa
   * propre dérive : aucune lecture de style dans la boucle, donc aucun
   * recalcul de mise en page.
   *
   * Le collage est conditionnel et mesuré : l'attribut data-fits n'est posé
   * que si le contenu tient dans la fenêtre, sinon le héro redevient une
   * section ordinaire et rien n'est coupé.
   */
  class FloatingHero extends HTMLElement {
    connectedCallback() {
      this.wrapper = this.closest('.shopify-section') || this.parentElement;
      this.inner = this.querySelector('[data-hero-inner]');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.ticking = false;

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onSectionLoad = this.onSectionLoad.bind(this);

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      document.addEventListener('shopify:section:load', this.onSectionLoad);

      // Les images décalent la mise en page : on remesure quand elles arrivent.
      this.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', this.onResize, { once: true });
      });

      this.measure();
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    onSectionLoad() {
      this.measure();
      this.update();
    }

    onResize() {
      this.measure();
      this.update();
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      this.frame = requestAnimationFrame(() => {
        this.ticking = false;
        this.update();
      });
    }

    measure() {
      if (!this.wrapper || !this.inner) return;
      var guard = 24;
      var needed = this.inner.getBoundingClientRect().height + guard;
      if (needed > 0 && needed <= window.innerHeight) {
        this.wrapper.setAttribute('data-fits', 'true');
      } else {
        this.wrapper.removeAttribute('data-fits');
      }
      this.sectionTop = this.documentTop(this.wrapper);
    }

    /**
     * Position de la section dans le flux. On somme les offsetTop plutôt que de
     * lire getBoundingClientRect : une fois la section collée, son rect reste à
     * 0 quel que soit le défilement, et la progression ne bougerait jamais.
     */
    documentTop(el) {
      var top = 0;
      var node = el;
      while (node) {
        top += node.offsetTop;
        node = node.offsetParent;
      }
      return top;
    }

    update() {
      if (!this.wrapper || this.reduced.matches) return;
      if (this.sectionTop == null) this.sectionTop = this.documentTop(this.wrapper);

      // Progression de 0 (héro plein cadre) à 1 (un écran défilé : la section
      // suivante l'a recouvert).
      var travelled = window.scrollY - this.sectionTop;
      var progress = travelled / window.innerHeight;
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;

      this.style.setProperty('--sy', progress.toFixed(4));
    }
  }

  if (!customElements.get('floating-hero')) {
    customElements.define('floating-hero', FloatingHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-sticky"] && !Shopify.designMode) return;
  try {
    
  /**
   * Héro collé.
   *
   * Le custom element porte tout le cycle de vie : l'éditeur de thème remplace
   * le DOM de la section, ce qui déclenche disconnectedCallback puis
   * connectedCallback. Aucun écouteur n'est donc lié deux fois. On écoute en
   * plus shopify:section:load pour re-mesurer quand une AUTRE section change de
   * hauteur au-dessus du héro.
   */
  class StickyHero extends HTMLElement {
    connectedCallback() {
      this.wrapper = this.closest('.shopify-section') || this.parentElement;
      this.inner = this.querySelector('[data-hero-inner]');
      this.veilMax = parseFloat(this.dataset.veilMax || '0.55');
      this.ticking = false;

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onSectionLoad = this.onSectionLoad.bind(this);

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      document.addEventListener('shopify:section:load', this.onSectionLoad);

      // Les images décalent la mise en page : on remesure quand elles arrivent.
      this.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', this.onResize, { once: true });
      });

      this.measure();
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    onSectionLoad() {
      this.measure();
      this.update();
    }

    onResize() {
      this.measure();
      this.update();
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      this.frame = requestAnimationFrame(() => {
        this.ticking = false;
        this.update();
      });
    }

    /**
     * Collage conditionnel : collé, le héro prend une hauteur fixe et masque son
     * débordement. S'il est plus haut que la fenêtre, son bas devient
     * inatteignable. On mesure donc la hauteur réellement occupée, marge de
     * garde comprise, plutôt que de comparer à un seuil écrit en dur.
     */
    measure() {
      if (!this.wrapper || !this.inner) return;
      var guard = 24;
      var needed = this.inner.getBoundingClientRect().height + guard;
      var fits = needed > 0 && needed <= window.innerHeight;
      if (fits) {
        this.wrapper.setAttribute('data-fits', 'true');
      } else {
        this.wrapper.removeAttribute('data-fits');
      }
      this.sectionTop = this.documentTop(this.wrapper);
    }

    /**
     * Position de la section dans le flux. On somme les offsetTop plutôt que de
     * lire getBoundingClientRect : une fois la section collée, son rect reste à
     * 0 quel que soit le défilement, et la progression ne bougerait jamais.
     */
    documentTop(el) {
      var top = 0;
      var node = el;
      while (node) {
        top += node.offsetTop;
        node = node.offsetParent;
      }
      return top;
    }

    update() {
      if (!this.wrapper) return;
      var viewport = window.innerHeight;
      if (this.sectionTop == null) this.sectionTop = this.documentTop(this.wrapper);
      var travelled = window.scrollY - this.sectionTop;
      var progress = travelled / (viewport * 0.5);
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;
      this.style.setProperty('--veil', (progress * this.veilMax).toFixed(3));
    }
  }

  if (!customElements.get('sticky-hero')) {
    customElements.define('sticky-hero', StickyHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('[data-stage]');
      this.querySelectorAll('.product__thumb').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (this.stage) this.stage.src = thumb.dataset.thumb;
          this.querySelectorAll('.product__thumb').forEach((t) => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });
    }
  }
  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }

  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.idInput = this.querySelector('[data-variant-id]');
      this.priceEl = this.querySelector('[data-price]');
      this.addBtn = this.querySelector('[data-add]');
      this.addLabel = this.querySelector('[data-add-label]');
      this.addedText = this.dataset.added;
      this.soldoutText = this.dataset.soldout;
      this.addtext = this.dataset.addtext;

      const script = this.querySelector('[data-variants]');
      this.variants = script ? JSON.parse(script.textContent) : [];

      this.querySelectorAll('input[type="radio"]').forEach((input) => {
        input.addEventListener('change', () => this.onOptionChange());
      });

      this.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-qty]');
        if (!btn) return;
        const input = this.querySelector('.qty__input');
        let value = parseInt(input.value, 10) || 1;
        value += btn.dataset.qty === 'up' ? 1 : -1;
        if (value < 1) value = 1;
        input.value = value;
      });

      if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));
    }

    onOptionChange() {
      const selected = [];
      this.querySelectorAll('.variant').forEach((fs) => {
        const checked = fs.querySelector('input:checked');
        selected.push(checked ? checked.value : null);
      });
      const variant = this.variants.find((v) =>
        v.options.every((opt, i) => opt === selected[i])
      );
      if (!variant) {
        this.addBtn.disabled = true;
        if (this.addLabel) this.addLabel.textContent = this.soldoutText;
        return;
      }
      this.idInput.value = variant.id;
      if (this.priceEl) this.priceEl.textContent = variant.price_money;
      this.addBtn.disabled = !variant.available;
      if (this.addLabel) this.addLabel.textContent = variant.available ? this.addtext : this.soldoutText;
    }

    onSubmit(event) {
      if (!window.fetch) return; // fallback : soumission classique
      event.preventDefault();
      const data = new FormData(this.form);
      this.addBtn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data })
        .then((r) => {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(() => this.refreshCart())
        .then(() => this.flashAdded())
        .catch(() => this.form.submit())
        .finally(() => { this.addBtn.disabled = false; });
    }

    refreshCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((cart) => {
          document.querySelectorAll('[data-cart-count]').forEach((el) => {
            el.textContent = cart.item_count;
            el.classList.toggle('is-empty', cart.item_count === 0);
          });
        });
    }

    flashAdded() {
      if (!this.addLabel) return;
      const original = this.addLabel.textContent;
      this.addLabel.textContent = this.addedText;
      setTimeout(() => { this.addLabel.textContent = original; }, 1800);
    }
  }
  if (!customElements.get('product-form')) {
    customElements.define('product-form', ProductForm);
  }

  } catch(e) { console.error(e); }
})();
})();
